import { VueReCaptcha } from "vue-recaptcha-v3";

const CaptchaUtils = {
    install(Vue, options) {
        const { siteKey } = options;

        Vue.prototype.$checkCaptcha = function () {
            return new Promise(resolve => {
                if (this.$recaptchaInstance) {
                    this.$recaptchaInstance.recaptcha.execute().then(token => {
                        resolve(token);
                    });
                } else {
                    resolve(null);
                }
            });
        };

        Vue.prototype.$resetCaptcha = function () {
            if (this.$recaptchaInstance) {
                this.$recaptchaInstance.recaptcha.reset();
            }
        };

        Vue.use(VueReCaptcha, { siteKey });
    }
};

export default CaptchaUtils;
